import Skeleton from '@/common/components/skeleton/Skeleton';
import useImageLoader from '@/common/hooks/useImage';
import { getMediaDirectSrc, getMediaFileId } from '../../utils/getMediaFileId';
import {
	StoryHeader,
	StoryHeaderClose,
	StoryMeta,
	StoryPlayToggle,
	StoryHeaderAvatarWrap,
} from '../../StoryViewer.styles';

const StoryViewerHeader = ({
	person,
	timeAgoLabel,
	isPaused,
	onPlayToggle,
	playLabel,
	pauseLabel,
	onClose,
	closeLabel,
}) => {
	const avatarId = getMediaFileId(person?.profile_image);
	const directAvatarSrc = getMediaDirectSrc(person?.profile_image);
	const { imageSrc: avatarSrc, isLoading } = useImageLoader(avatarId);
	const resolvedAvatarSrc = avatarSrc || directAvatarSrc || person?.image;
	const showAvatarSkeleton =
		Boolean(avatarId) && (isLoading || !resolvedAvatarSrc);

	return (
		<StoryHeader>
			<StoryHeaderAvatarWrap>
				{showAvatarSkeleton && (
					<Skeleton
						width="100%"
						height="100%"
						radius="50%"
						minWidth="100%"
						minHeight="100%"
					/>
				)}
				{resolvedAvatarSrc && (
					<img src={resolvedAvatarSrc} alt="" />
				)}
			</StoryHeaderAvatarWrap>
			<StoryMeta>
				<strong>{person.name?.toLowerCase()}</strong>
				<span>{timeAgoLabel}</span>
			</StoryMeta>
			<StoryPlayToggle
				type="button"
				$paused={!isPaused}
				onClick={onPlayToggle}
				aria-label={isPaused ? playLabel : pauseLabel}
			>
				<span aria-hidden="true" />
			</StoryPlayToggle>
			{onClose ? (
				<StoryHeaderClose type="button" onClick={onClose} aria-label={closeLabel}>
					×
				</StoryHeaderClose>
			) : null}
		</StoryHeader>
	);
};

export default StoryViewerHeader;
